module.exports = {"id":"203782","name":"Ahmad Benali","rating":"72","photo":"./data/images/photos/4/203782.png","club":{"name":"Crotone","logo":"./data/images/clubs/Crotone.png"},"positions":["AD","ATT","AG"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/AhmadBenali0.json
// module id = 126
// module chunks = 0